<template>
  <b-sidebar
    id="sidebar-right-order"
    :width="width"
    right
    backdrop
    body-class="p-0"
    no-header
    no-close-on-backdrop
    no-close-on-route-change
    lazy
    @hidden="closeOrderWidget"
  >
    <template #default="{ hide }">
      <div class="detail-widget">
        <div class="detail-widget__field detail-widget__left">
          <div class="detail-widget__top">
            <b-icon-arrow-bar-left
              class="detail-widget__back cursor-pointer"
              font-scale="2"
              @click="hide"
            ></b-icon-arrow-bar-left>
            <b-skeleton-wrapper :loading="isLoading">
              <template #loading>
                <b-skeleton height="35px"></b-skeleton>
                <b-skeleton class="mt-2" height="30px"></b-skeleton>
              </template>

              <div class="top">
                <h2 class="title text-light mb-0 position-relative">Заказ #{{ items.id }}
                  <template v-if="items.text_mark">
                    <span class="font-size-14">{{ items.text_mark }}</span>
                  </template>
                  <b-badge variant="secondary" class="position-absolute fs11px ml-2">{{ getOrderStatusName }}</b-badge>
                </h2>
                <div class="buttons">
                  <button
                    class="mr-2 btn btn-outline-light"
                    @click="
                      $router.push({
                        query: {
                          ...$route.query,
                          'edit-order': !editStatus,
                        },
                      })
                    "
                  >
                    {{ editStatus ? "Отмена" : "Редактировать" }}
                  </button>

                  <button
                    v-if="!isAgent"
                    class="mr-2 btn btn-outline-light"
                    @click="openCreateTaskSidebar"
                  >
                    Создать задачу
                  </button>

                  <button
                    class="mr-2 btn btn-outline-light show-history-button"
                    @click="viewCommentsBlock"
                  >
                    {{ showButtonText }}
                  </button>

                  <b-button @click="refreshOrder" size="sm" variant="outline-light">
                    <b-icon
                      icon="arrow-repeat"
                      scale="1.5"
                      aria-label="Reload"
                      :animation="isLoading ? 'spin' : ''"
                    ></b-icon>
                  </b-button>
                </div>
              </div>
              <div class="d-flex justify-content-between align-items-center mt-2">
                <h3 class="subtitle text-light mb-0">
                  {{ companyName ? companyName : "..." }}
                </h3>
                
                <div class="order-status-buttions">
                   <!-- Кнопки управления заказом/поставкой -->
                   <button
                     v-if="items.reference_status_id != 362 && (items.reference_order_type_id == 1 || [359, 360, 539, 540, 541, 542, 543, 544, 545].includes(items.reference_status_id))"
                     @click="closeOrder(items.id)"
                     type="button"
                     class="btn btn-outline-light ml-2"
                   >
                     <template v-if="items.reference_order_type_id == 2">
                       Отменить поставку
                     </template>
                     <template v-else>
                       Закрыть заявку
                     </template>
                   </button>

                   <button
                     v-if="items.reference_status_id == 424"
                     type="button"
                     class="btn btn-outline-light ml-2"
                     @click="changeOrderStatus(items.id, 959)"
                   >
                     Невозможно взыскать
                   </button>

                   <button
                     v-if="items.reference_order_type_id == 2 && ![361, 362, 421, 424].includes(items.reference_status_id)"
                     type="button"
                     class="btn btn-outline-light ml-2"
                     @click="changeOrderStatus(items.id, 361)"
                   >
                     Завершить поставку
                   </button>

                   <button
                     v-if="(items.reference_order_type_id == 2 && items.reference_status_id == 361) || items.reference_status_id == 424"
                     type="button"
                     class="btn btn-outline-light ml-2"
                     @click="changeOrderStatus(items.id, 421)"
                   >
                     Закрыть поставку
                   </button>

                   <button
                     v-if="items.reference_status_id == 362 || items.reference_status_id == 959"
                     type="button"
                     class="btn btn-outline-light ml-2"
                     @click="changeOrderStatus(items.id, 359)"
                   >
                     Возобновить работу
                   </button>
                   <button
                     v-if="items.reference_order_type_id == 1 && ![421, 362].includes(items.reference_status_id)"
                     class="btn btn-outline-primary text-white ml-2"
                     :disabled="items.loading || items.reference_status_id == 541"
                     :title="items.reference_status_id == 541 ? 'Из этого статуса заказ нельзя перевести в Поставку' : ''"
                     @click="makeOrderSupplyByID(items.id)"
                   >
                     Перевести в поставку
                   </button>
                 </div>
              </div>
            </b-skeleton-wrapper>

            <button
              class="detail-widget__top-copy-button"
              @click="copyLink"
            >
              <b-icon
                icon="link45deg"
                scale="2"
              ></b-icon>
            </button>
          </div>

          <div class="detail-widget__card">
            <b-overlay class="h-100" :show="isLoading">
              <template v-if="items.id">
                <OrderCreateOrEdit
                  v-if="editStatus"
                  class="pt-3"
                  :editedItem="items"
                  @change-order="setEditOrderData"
                >
                  <template #footer>
                    <b-overlay
                      :show="saving"
                      rounded
                      opacity="0.8"
                      spinner-small
                      spinner-variant="success"
                      class="ml-auto"
                    >
                      <b-button
                        variant="success"
                        class="text-right"
                        @click="updateOrder"
                      >
                        Сохранить изменения
                      </b-button>
                    </b-overlay>
                  </template>
                </OrderCreateOrEdit>

                <b-tabs
                  lazy
                  v-show="!editStatus"
                  nav-class="nav-widget"
                  nav-wrapper-class="p-0"
                >
                  <b-tab @click="deleteQueryTab">
                    <template #title>
                      <div>Детали</div>
                    </template>
                    
                    <tsoft-order-details
                      :detailedItem="items"
                      @closeOrder="closeOrder"
                      @changeOrderStatus="changeOrderStatus"
                      @changeCreatorUserId="changeCreatorUserId"
                      @makeOrderSupplyByID="makeOrderSupplyByID"
                      @openServiceDistributionModal="openServiceDistributionModal"
                      @updateOrderHistory="updateOrderHistory"
                      @fullOrderUpdate="fullOrderUpdate"
                    ></tsoft-order-details>

                    <InstructionText 
                      v-if="isAgent"
                      userType="agent" 
                      section="order-details"
                      :contextData="items"
                    />

                    <!-- MODAL -->
                    <tsoft-order-service-distribution
                      :isOpenServiceDistributionModal.sync="
                        isOpenServiceDistributionModal
                      "
                      :editedItem="items"
                      modalKey="orderShowOne"
                    ></tsoft-order-service-distribution>
                  </b-tab>

                  <b-tab
                    v-if="items.outsourcing_order === 1"
                    :active="orderTab === 'outsourcing'"
                    @click="setRefreshKey"
                  >
                    <template #title>
                      <div>Расчёты</div>
                    </template>
                    
                    <tsoft-order-outsourcing
                      :order_id="items.id"
                    />

                    <InstructionText 
                      v-if="isAgent"
                      userType="agent" 
                      section="order-outsourcing"
                      :contextData="items"
                    />
                  </b-tab>
  
                  <b-tab
                    v-if="items.set_services_ids.includes(22)"
                    :active="orderTab === '22'"
                    @click="setRefreshKey"
                  >
                    <template #title>
                      <div>Таможенное оформление</div>
                    </template>
                    
                    <tsoft-order-service-details
                      :key="refreshKey"
                      :order_id="items.id"
                      :reference_service_id="22"
                      @setServiceInfo="setServiceInfo"
                      @makeOrderSupply="handleMakeOrderSupply"
                      @orderUpdated="handleOrderUpdated"
                    ></tsoft-order-service-details>

                    <InstructionText 
                      v-if="isAgent"
                      userType="agent" 
                      section="order-customs"
                      :contextData="items"
                    />
                  </b-tab>

                  <b-tab
                    v-if="items.set_services_ids.includes(24)"
                    :active="orderTab === '24'"
                    @click="setRefreshKey"
                  >
                    <template #title>
                      <div>Сертификация</div>
                    </template>
                    
                    <tsoft-order-service-details
                      :key="refreshKey"
                      :order_id="items.id"
                      :reference_service_id="24"
                      @setServiceInfo="setServiceInfo"
                      @makeOrderSupply="handleMakeOrderSupply"
                      @orderUpdated="handleOrderUpdated"
                    ></tsoft-order-service-details>

                    <InstructionText 
                      v-if="isAgent"
                      userType="agent" 
                      section="order-certification"
                      :contextData="items"
                    />
                  </b-tab>

                  <b-tab
                    v-if="items.set_services_ids.includes(25)"
                    :active="orderTab === '25'"
                    @click="setRefreshKey"
                  >
                    <template #title>
                      <div>Консалтинг и сопутсвующие услуги</div>
                    </template>
                    
                    <tsoft-order-service-details
                      :key="refreshKey"
                      :order_id="items.id"
                      :reference_service_id="25"
                      @setServiceInfo="setServiceInfo"
                      @makeOrderSupply="handleMakeOrderSupply"
                      @orderUpdated="handleOrderUpdated"
                    ></tsoft-order-service-details>

                    <InstructionText 
                      v-if="isAgent"
                      userType="agent" 
                      section="order-consulting"
                      :contextData="items"
                    />
                  </b-tab>

                  <b-tab
                    v-if="items.set_services_ids.includes(23)"
                    :active="orderTab === '23'"
                    @click="setRefreshKey"
                  >
                    <template #title>
                      <div>Логистика</div>
                    </template>
                    
                    <tsoft-order-service-details
                      :key="refreshKey"
                      :order_id="items.id"
                      :reference_service_id="23"
                      @setServiceInfo="setServiceInfo"
                      @changeOrderToQuotationSent="handleChangeOrderToQuotationSent"
                      @makeOrderSupply="handleMakeOrderSupply"
                      @orderUpdated="handleOrderUpdated"
                    ></tsoft-order-service-details>

                    <InstructionText 
                      v-if="isAgent && items.reference_order_type_id == 1"
                      userType="agent" 
                      section="order-logistics-request"
                      :contextData="items"
                    />
                    <InstructionText 
                      v-if="isAgent && items.reference_order_type_id == 2"
                      userType="agent" 
                      section="order-logistics-supply"
                      :contextData="items"
                    />
                  </b-tab>

                  <b-tab
                    v-if="items.set_services_ids.includes(75)"
                    :active="orderTab === '75'"
                    @click="setRefreshKey"
                  >
                    <template #title>
                      <div>ПНК</div>
                    </template>
                    
                    <tsoft-order-service-details
                      :key="refreshKey"
                      :order_id="items.id"
                      :reference_service_id="75"
                      @setServiceInfo="setServiceInfo"
                      @makeOrderSupply="handleMakeOrderSupply"
                      @orderUpdated="handleOrderUpdated"
                    ></tsoft-order-service-details>

                    <InstructionText 
                      v-if="isAgent"
                      userType="agent" 
                      section="order-pnk"
                      :contextData="items"
                    />
                  </b-tab>

                  <b-tab
                    v-if="items.set_services_ids.includes(76)"
                    :active="orderTab === '76'"
                    @click="setRefreshKey"
                  >
                    <template #title>
                      <div>СВХ</div>
                    </template>
                    
                    <tsoft-order-service-details
                      :key="refreshKey"
                      :order_id="items.id"
                      :reference_service_id="76"
                      @setServiceInfo="setServiceInfo"
                      @makeOrderSupply="handleMakeOrderSupply"
                      @orderUpdated="handleOrderUpdated"
                    ></tsoft-order-service-details>

                    <InstructionText 
                      v-if="isAgent"
                      userType="agent" 
                      section="order-svh"
                      :contextData="items"
                    />
                  </b-tab>

                  <b-tab
                    v-if="items.set_services_ids.includes(77)"
                    :active="orderTab === '77'"
                    @click="setRefreshKey"
                  >
                    <template #title>
                      <div>Страхование</div>
                    </template>
                    
                    <tsoft-order-service-details
                      :key="refreshKey"
                      :order_id="items.id"
                      :reference_service_id="77"
                      @setServiceInfo="setServiceInfo"
                      @makeOrderSupply="handleMakeOrderSupply"
                      @orderUpdated="handleOrderUpdated"
                    ></tsoft-order-service-details>

                    <InstructionText 
                      v-if="isAgent"
                      userType="agent" 
                      section="order-insurance"
                      :contextData="items"
                    />
                  </b-tab>

                  <b-tab
                    :active="orderTab === 'order-documents'"
                    v-if="!items.short_order"
                  >
                    <template #title>
                      <div>Документы</div>
                    </template>
                    
                    <tsoft-show-edit-documents
                      :orderId="items.id"
                      :companyId="items.company_id"
                      :updateListDocument="singleOrMultiDocuments"
                      @clearDocumentList="clearDocumentList"
                      requestDocuments
                    />
                    <tsoft-create-documents
                      v-if="items.reference_status_id != 421"
                      :orderId="items.id"
                      :companyId="items.company_id"
                      :needMultiUploadDocuments="true"
                      @updateViewDocument="documentOutput"
                    />
                    <div
                      class="document_view_order"
                      v-if="items.company_id && documentIdsFromCompany.length > 0"
                    >
                      <h5>Документы по услугам в компании</h5>
                      <tsoft-show-edit-documents
                        :companyId="items.company_id"
                        :referenceDocumentTypeIds="documentIdsFromCompany"
                        :updateDocumentList="documentIdsFromCompany.length"
                        :noActions="true"
                        requestDocuments
                      />
                    </div>

                    <InstructionText 
                      v-if="isAgent"
                      userType="agent" 
                      section="order-documents"
                      :contextData="items"
                    />
                  </b-tab>

                  <b-tab
                    :active="orderTab === 'order-finance'"
                    v-if="items.reference_order_type_id == 2"
                  >
                    <template #title>
                      <div>Счета</div>
                    </template>
                    
                    <tsoft-finance-finder-creator
                      id="invoiceToOrder"
                      :exportXLSX="`Счета по заказу #${items.id}`"
                      :order_id="items.id"
                      :company_id="items.company_id"
                      :allowed_services="items.services"
                      :full_order="items"
                      :additionalGetParameter="`&order_id=${items.id}`"
                      typeOfTableFilter="finance"
                      :isNeedCreate="items.reference_status_id != 421 ? true : false"
                    >
                    </tsoft-finance-finder-creator>

                    <InstructionText 
                      v-if="isAgent"
                      userType="agent" 
                      section="order-finance"
                      :contextData="items"
                    />
                  </b-tab>
<!-- 
                  <b-tab 
                    v-if="items.reference_order_type_id == 2"
                    :active="orderTab === 'order-finance-virtuals'"
                  >
                    <template #title>
                      <span>Виртуальные счета</span>
                    </template>
                    <FinanceVirtualFinderAndCreator
                      :isNeedCreate="true"
                      :order_id="items.id"
                      :additionalGetParameter="`&order_id=${items.id}`" 
                    ></FinanceVirtualFinderAndCreator>
                  </b-tab> -->

                  <b-tab
                    :active="orderTab === 'order-finance-requests'"
                    v-if="items.reference_order_type_id == 2"
                  >
                    <template #title>
                      <div>Запросы</div>
                    </template>
                    
                    <tsoft-finance-requests-by-parameters
                      :additionalGetParameter="`&order_id=${items.id}`"
                      :isNeedCreate="false"
                    />

                    <InstructionText 
                      v-if="isAgent"
                      userType="agent" 
                      section="order-finance-requests"
                      :contextData="items"
                    />
                  </b-tab>

                  <b-tab
                    v-if="!isAgent"
                  >
                    <template #title>
                      <div>Задачи</div>
                    </template>
                    
                    <tsoft-history-task
                      modelName="order_id"
                      :modelId="items.id"
                      :changeLoadTaskList="taskStatusUpdate"
                    />

                    <InstructionText 
                      v-if="isAgent"
                      userType="agent" 
                      section="order-tasks"
                      :contextData="items"
                    />
                  </b-tab>
                  
                  <b-tab
                    v-if="isUserCanSeeOrderSuppliers"
                    :active="orderTab === 'order-suppliers'"
                  >
                    <template #title>
                      <div>Поставщики</div>
                    </template>
                    
                    <OrderWorkWithSuppliers
                      :orderId="items.id"
                      :additionalGetParameter="`&order_id=${items.id}`"
                    />

                    <InstructionText 
                      v-if="isAgent"
                      userType="agent" 
                      section="order-suppliers"
                      :contextData="items"
                    />
                  </b-tab>

                </b-tabs>
              </template>
            </b-overlay>
          </div>
        </div>

        <div
          ref="orderDetailWidget"
          :style="{ maxWidth: `${widthRightBar}px` }"
          class="detail-widget__field detail-widget__right resizable-bar"
        >
          <div
            @mousedown="mouseDown($event, 'orderDetailWidget', 600)"
            @dblclick="viewCommentsBlock"
            class="drag-line"
          ></div>
          <b-skeleton-wrapper
            class="h-100 d-flex flex-column"
            :loading="isLoading"
          >
            <template #loading>
              <div v-for="(skeleton, index) in 4" class="p-3">
                <div class="d-flex align-items-center mb-3">
                  <b-skeleton
                    class="mr-3 flex-shrink-0"
                    type="avatar"
                  ></b-skeleton>
                  <b-skeleton width="100%"></b-skeleton>
                </div>
                <b-skeleton height="10px"></b-skeleton>
                <b-skeleton class="my-3" height="10px"></b-skeleton>
              </div>
              <b-skeleton class="mt-auto" height="200px"></b-skeleton>
            </template>

            <div class="d-flex flex-column h-100">
              <HistoryOrder
                :data="history" 
                :order_id="orderID"
                :order="items"
                @updateData="getHistory" 
                @replyComment="replyComment" 
                @editComment="editComment"
                @scrollToRepliedComment="scrollToRepliedComment"
              />
              <CommentSubmitForm
                :needFileUploadButton="true"
                :loading="savingComment"
                :listOfUsers="allUsersFromOrder"
                :id-comment="idComment"
                :is-reply="isReply"
                :text="text"
                :old-value="oldValue"
                :is-need-to-refresh="isNeedToRefresh"
                :order-id="items.id"
                :company_id="items.company_id"
                :outbound_number="items.company_employee ? items.company_employee.lead_phone:'89150670468'"
                :target_id="items.id"
                target_type="order"
                @setUsersForNotifications="setUsersForNotifications"
                @addFiles="addFiles"
                @submit="submitComment"
                @cancelReplyOrEdit="cancelReplyOrEdit"
                @setReplyComment="setReplyComment"
                @setEditComment="setEditComment"
                @refreshed="refreshed"
                @updateOrderHistory="updateOrderHistory"
                @setToGetAllHistoryTasks="taskStatusUpdate = !taskStatusUpdate"
              />
            </div>
          </b-skeleton-wrapper>
        </div>
      </div>

      <CreateTaskWidget
        :order-id="items.id"
        @setToGetAllHistoryTasks="taskStatusUpdate = !taskStatusUpdate"
        @openCreateTaskSidebar="openCreateTaskSidebar"
      />
    </template>
  </b-sidebar>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import {
  API_ORDERS,
  API_ORDERS_ACTION_HISTORY,
  SERVICE_TO_DOCUMENT,
} from "@/constants";

import CommentSubmitForm from "@components/comments/CommentSubmitForm";
import OrderCreateOrEdit from "@components/orders/OrderCreateOrEdit";
import InstructionText from "@components/common/InstructionText";

import tsoftOrderServiceDetails from "@components/orders/OrderServiceDetails";
import tsoftFinanceFinderAndCreator from "@components/finance/FinanceFinderAndCreator";
import tsoftFinanceRequestsByParameters from "@components/finance/FinanceRequestsByParameters";
import tsoftOrderServiceDistribution from "@components/orders/OrderServiceDistribution";
import tsoftOrderDetails from "@components/orders/OrderDetails";
import tsoftOrderOutsourcing from "@components/orders/OrderOutsourcing";
import OrderWorkWithSuppliers from "@components/orders/OrderWorkWithSuppliers";
import FinanceVirtualFinderAndCreator from "@components/finance/FinanceVirtualFinderAndCreator";
import HistoryOrder from "@components/orders/detailWidget/History";
import CreateTaskWidget from '@/components/task/CreateTaskWidget.vue';

import { mixinDocuments } from "@/mixins/mixinDocuments";
import { mixinComments } from "@/mixins/mixinComments";
import { orderMethods, defaultDataItems, copyLink } from "@/mixins";
import { openCreateTaskSidebar } from '@/mixins/openTasksSidebar';

export default {
  components: {
    HistoryOrder,
    CommentSubmitForm,
    OrderCreateOrEdit,
    InstructionText,
    "tsoft-order-details": tsoftOrderDetails,
    "tsoft-order-service-details": tsoftOrderServiceDetails,
    "tsoft-finance-finder-creator": tsoftFinanceFinderAndCreator,
    "tsoft-finance-requests-by-parameters": tsoftFinanceRequestsByParameters,
    "tsoft-order-service-distribution": tsoftOrderServiceDistribution,
    tsoftOrderOutsourcing,
    FinanceVirtualFinderAndCreator,
    CreateTaskWidget,
    OrderWorkWithSuppliers
  },

  mixins: [
    mixinDocuments,
    orderMethods,
    mixinComments,
    openCreateTaskSidebar,
    defaultDataItems,
    copyLink,
  ],

  metaInfo() {
    return {
      title: `Заказ #${this.orderID}`,
    };
  },

  props: {
    width: {
      type: String,
      require: true,
    }
  },

  data() {
    return {
      items: {},
      history: [],
      taskStatusUpdate: false,
      isLoading: true,
      editOrderData: {},
      refreshKey: 0,
      saving: false,
      savingComment: false,
      files: [],
      usersForNotifications: [],
      allUsersFromOrder: [],
      apiName: 'order',
      idName: 'order_id',
      countOfWidthRightBar: '',
    };
  },

  watch: {
    orderID(value) {
      if (!!value) {
        this.refreshOrder();
      }
    },
  },

  computed: {
    ...mapGetters("auth", ["currentUser"]),

    widthRightBar() {
      if (typeof localStorage.userSettings === "undefined" || localStorage.userSettings === null) {
        localStorage.setItem("userSettings", '{"orderDetailWidget":436, "tablePerPage":25}');
      }
      return JSON.parse(localStorage.getItem("userSettings")).orderDetailWidget;
    },

    hasData() {
      return !_.isEmpty(this.items);
    },

    orderID() {
      return this.$route.query.order;
    },

    orderTab() {
      return this.$route.query['tab-order'];
    },

    companyName() {
      return this.items.company && this.items.company.name
        ? this.items.company.name
        : this.items.temp_name;
    },

    documentIdsFromCompany() {
      return this.items.set_services_ids.map((id) => SERVICE_TO_DOCUMENT[id]);
    },

    editStatus() {
      return this.$route.query['edit-order'] === "true";
    },

    currentId() {
      return this.$route.query.order;
    },

    showButtonText() {
      return this.countOfWidthRightBar <= 10 ? "Открыть чат" : "Скрыть чат";
    },

    getOrderStatusName() {
      return (this.items.reference_status_id && this.$store.state.referencePropertiesList.list[this.items.reference_status_id]) ? this.$store.state.referencePropertiesList.list[this.items.reference_status_id].text : '...';
    },

    isUserCanSeeOrderSuppliers() {
      // Роли, которые могут видеть
      const allowedRoles = [
        'administrator',
        'president',
        'logistics-head-manager',
        'logistics-manager',
        'logistics-multim-head-manager',
        'logistics-multim-manager',
        'TO-manager',
        'TO-head-manager',
        'bsz-manager'
      ];
      
      return allowedRoles.some(role => this.currentUser.role.includes(role));
    },

    isAgent() {
      return this.currentUser.role.includes('agent');
    }  
  },

  methods: {
    ...mapActions(["GET_REFERENCE_PROPERTIES"]),
    ...mapActions("orderDetail", [
      "orderWidgetSetValue",
      "orderWidgetSetStatus",
      "orderWidgetSetChangedColumns",
    ]),

    // does not used
    resetData() {
      (this.items = {}),
        (this.history = []),
        (this.taskStatusUpdate = false),
        (this.isLoading = true);
    },

    async getOrder() {
      const { data } = await axios.get(`${API_ORDERS}/${this.orderID}`);
      this.items = data;
      this.getAllUsersFromOrderForNotificationList()
    },

    async getHistory() {
      await axios
        .get(`${API_ORDERS_ACTION_HISTORY}/${this.orderID}`)
        .then(({ data }) => {
          this.history = data.reverse();
          this.getAllUsersFromOrderForNotificationList();
          this.cancelReplyOrEdit();
        });
    },

    setUsersForNotifications(users) {
      this.usersForNotifications = users;
    },

    setServiceInfo(service_id, data) {
      if (!this.items.services_info) {
        this.$set(this.items, "services_info", {});
      }
      this.items.services_info[service_id] = data;
    },

    changeCreatorUserId(id, data, index) {
      this.updateAnyOrder(id, data, index).finally(() => {
        this.getOrder();
        this.getHistory();
      });
    },

    async makeOrderSupplyByID(id) {
      this.items.loading = true;
      let message = await this.finalFormValidate(this.items);
      const updateFields = {
        reference_order_type_id: 2,
        reference_status_id: 359,
        makingOrderSupply: true,
      };

      if (message.length == 0) {
        this.updateAnyOrder(id, updateFields).finally(() => {
          this.getOrder();
          this.getHistory();
        });
      } else {
        this.items.loading = false;
        const h = this.$createElement;
        const vNodesMsg = h("ul", message);
        this.$bvToast.toast([vNodesMsg], {
          title: `Невозможно перевести заказ #${this.items.id} в Поставку, заполните все необходимые поля`,
          variant: "warning",
          solid: true,
          noAutoHide: true,
        });
      }
    },

    openServiceDistributionModal() {
      this.isOpenServiceDistributionModal = true;
    },

    closeOrder(val) {
      this.closeOrderByIndex(val).then(() => {
        this.getOrder();
        this.getHistory();
      });
    },

    changeOrderStatus(id, newStatus = 361) {
      this.isLoading = true;
      
      // Сохраняем старый статус для сравнения
      const oldStatus = this.items.reference_status_id;

      this.changeOrderStatusByID(id, newStatus).then((data) => {
        this.getOrder();
        this.getHistory();
        if (newStatus !== oldStatus) {
          this.orderWidgetSetChangedColumns([
            newStatus,
            oldStatus,
          ]);
        }
        this.isLoading = false;
        this.$emit("allOrdersUpdater", -1, id);
        
        // Эмитим событие для обновления данных в дочерних компонентах только если статус действительно изменился
        if (data === true && newStatus !== oldStatus) {
          this.$emit("orderUpdated", {
            orderId: id,
            message: 'Статус заказа обновлен'
          });
        }
      });
    },

    setRefreshKey() {
      this.refreshKey++;
    },

    async handleOrderUpdated(data) {
      await this.refreshOrder();
      
      // Показываем тост с сообщением из события, если оно есть
      if (data && data.message) {
        this.$bvToast.toast(data.message, {
          title: 'Обновление данных заказа',
          variant: 'info',
          solid: true,
          autoHideDelay: 12000
        });
      }
    },

    async refreshOrder() {
      this.isLoading = true;

      await Promise.all([this.getHistory(), this.getOrder()]);
      this.loadTO();
      this.isLoading = false;
    },

    handleChangeOrderToQuotationSent(orderId, newStatus) {
      // Вызываем существующий метод changeOrderStatus с правильными параметрами
      this.changeOrderStatus(orderId, newStatus);
    },

    handleMakeOrderSupply(orderId) {
      // Вызываем метод для перевода заказа в поставку
      this.makeOrderSupplyByID(orderId);
    },

    updateOrderHistory() {
      this.getHistory();
    },

    fullOrderUpdate() {
      this.getOrder();
      this.getHistory();
    },

    async updateOrder() {
      this.saving = true;
      const { data } = await axios.put(
        `${API_ORDERS}/${this.orderID}`,
        this.editOrderData
      );
      this.$router.push({
        query: {
          ...this.$route.query,
          'edit-order': false,
        },
      });
      this.getOrder();
      this.orderWidgetSetValue(data);
      this.$toast.success("Изменения сохранены");
      this.saving = false;
    },

    setEditOrderData(value) {
      this.editOrderData = value;
    },

    closeOrderWidget() {
      const query = Object.assign({}, this.$route.query);
      delete query['edit-order'];
      delete query['tab-order'];
      delete query.order;
      this.$router.replace({ query });
      this.orderWidgetSetStatus("closed");
    },

    deleteQueryTab() {
      if (this.$route.query['tab-order']) {
        const query = Object.assign({}, this.$route.query);
        delete query['tab-order'];
        this.$router.replace({ query });
      }
    },

    getAllUsersFromOrderForNotificationList() {
      if (this.items.id) {
        if (this.currentUser.id) { this.allUsersFromOrder.push({ name: this.currentUser.name, value: this.currentUser.id }) }
        if (this.items.creator && this.items.creator.name) { this.allUsersFromOrder.push({ name: this.items.creator.name, value: this.items.creator.id }) }
        if (this.items.optional_sales_manager) { this.allUsersFromOrder.push({ name: this.items.optional_sales_manager.name, value: this.items.optional_sales_manager.id }) }
        if (this.items.company && this.items.company.sales_manager) { this.allUsersFromOrder.push({ name: this.items.company.sales_manager.name, value: this.items.company.sales_manager.id }) }
        if (this.items.service_users.length) {
          this.items.service_users.forEach(user => {
            this.allUsersFromOrder.push({ name: user.user.name, value: user.user.id })
          })
        }
      }

      if (this.history.length) {
        this.history.forEach(elem => {
          if (elem.creator_user_id) {
            this.allUsersFromOrder.push({ name: this.userNameId(elem.creator_user_id), value: elem.creator_user_id })
          }
        })
      }

      this.allUsersFromOrder = this.allUsersFromOrder.filter((user, index, self) => 
        index === self.findIndex((t) => (t.value === user.value && t.name === user.name)) && 
        user.value !== 1
      )
    },

    isCommentOpened() {
      try {
        const saved = localStorage.getItem("userSettings");
        const parsed = saved ? JSON.parse(saved) : null;
        const defaultWidth = 420; // default opened width
        const width = parsed && typeof parsed.orderDetailWidget !== 'undefined'
          ? parsed.orderDetailWidget
          : defaultWidth;

        this.countOfWidthRightBar = width;

        // ensure storage has a valid object so subsequent reads are safe
        if (!parsed || typeof parsed.orderDetailWidget === 'undefined') {
          localStorage.setItem("userSettings", JSON.stringify({ orderDetailWidget: width }));
        }
      } catch (e) {
        this.countOfWidthRightBar = 420;
        localStorage.setItem("userSettings", JSON.stringify({ orderDetailWidget: 420 }));
      }
    },

    viewCommentsBlock() {
      if (this.countOfWidthRightBar === 2) {
        this.$refs.orderDetailWidget.style.maxWidth = '500px';
        localStorage.setItem('userSettings', '{"orderDetailWidget": 500}');
      } else {
        this.$refs.orderDetailWidget.style.maxWidth = '2px';
        localStorage.setItem("userSettings", '{"orderDetailWidget": 2}');
      }
      this.isCommentOpened();
    },

    mouseDown(e, elemName, maxWidth) {
      const el = this.$refs[elemName];
      this.setListener(e, el, elemName, maxWidth);
    },

    setListener(e, el, elemName, maxWidth) {
      const BORDER_SIZE = 2;
      const DEFAULT_SIZE = maxWidth;
      const dragElement = el.children[0];

      function resize(e) {
        let m_pos = window.innerWidth - e.x;

        if (m_pos >= BORDER_SIZE) {
          el.style.maxWidth = `${m_pos}px`;
          localStorage.setItem(
            "userSettings",
            JSON.stringify({
              [elemName]: m_pos,
            })
          );
        }

        if (m_pos > DEFAULT_SIZE) {
          el.style.maxWidth = `${DEFAULT_SIZE}px`;
          localStorage.setItem(
            "userSettings",
            JSON.stringify({
              [elemName]: DEFAULT_SIZE,
            })
          );
        }

        if (m_pos <= BORDER_SIZE) {
          el.style.maxWidth = `${BORDER_SIZE}px`;
          localStorage.setItem(
            "userSettings",
            JSON.stringify({
              [elemName]: BORDER_SIZE,
            })
          );
        }
      }

      const mouseUp = () => {
        this.isCommentOpened();
        el.classList.remove("moved");
        window.removeEventListener("mousemove", resize);
        window.removeEventListener("mouseup", mouseUp);
      }

      if (e.target === dragElement) {
        el.classList.add("moved");
        window.addEventListener("mousemove", resize);
      }

      window.addEventListener("mouseup", mouseUp);
    },
    loadTO() {
      this.items.set_services_ids.forEach(ids => {
        api
          .call('get', `/api/orders/${this.orderID}/services/${ids}`)
          .then(({data}) => {
            this.setServiceInfo(data.id, data.data)
          })
      })
    },
  },

  mounted() {
    this.refreshOrder();
    this.orderWidgetSetStatus("opened");
    if (window.innerWidth > 991) {
      this.isCommentOpened();
    }
  },
};
</script>

<style lang="scss" scoped>
$bg-top: #0d6247;

.top {
  display: flex;
  align-items: center;

  @media screen and (max-width: 991px) {
    flex-wrap: wrap;
    padding-top: 5px;
  }
}

.buttons {
  margin-left: auto;
  @media screen and (max-width: 991px) {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-top: 20px;
    margin-left: 0px;
  }
}

.textarea-form {
  min-width: 400px;
  @media screen and (max-width: 991px) {
    min-width: 100%;
  }
}

.title {
  @media screen and (max-width: 991px) {
    font-size: 1rem;
    width: 100%;
  }
}

.subtitle {
  @media screen and (max-width: 991px) {
    font-size: 1.1rem;
    margin-left: 0px;
  }
}

.detail-widget {
  display: flex;
  position: absolute;
  width: 100%;
  height: 100%;
  background: #fff;

  @media screen and (max-width: 991px) {
    flex-direction: column;
    position: relative;
  }

  &__left {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    overflow-x: hidden;
    @media screen and (max-width: 991px) {
      min-height: 100vh;
    }
  }

  &__right {
    width: 100%;
    background-color: #f5f5f5;
    position: relative;
    @media screen and (max-width: 991px) {
      max-width: 100% !important;
    }

    &.collapses {
      transition: width 0.3s;
    }
  }

  &__top {
    position: relative;
    color: #fff;
    background-color: $bg-top;
    padding: 15px 1.5rem 15px 3rem;
    min-height: 110px;

    &-copy-button {
      position: absolute;
      top: 60px;
      left: 10px;
      border: none;
      outline: none;
      background-color: transparent;
      color: #fff;
    }
  }

  &__card {
    flex: 1;
    overflow-x: hidden;

    ::v-deep .tabs {
      display: flex;
      height: 100%;
      margin: 0;
      @media screen and (max-width: 991px) {
        flex-direction: column;
      }

      .nav-widget {
        background-color: $bg-top;
        height: 100%;
        flex-wrap: nowrap;
        overflow: auto;
        min-width: 130px;
        width: 100%;
        flex-direction: column;
        @media screen and (max-width: 991px) {
          flex-direction: row;
          height: auto;
          overflow-y: hidden;
        }
        .nav-link {
          text-align: left;
          border-radius: 0 !important;
          padding: 15px 10px !important;
          font-size: 14px !important;
          line-height: 1.1;
          font-weight: 700;
          color: #fff;
          min-width: 100px;
          border: none;
          text-transform: uppercase;
          @media screen and (max-width: 991px) {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 100%;
            padding: 10px !important;
          }
          &.active {
            color: #000 !important;
            background-color: #fff;
          }
          &:hover {
            color: #000 !important;
            background: #fff;
          }
        }
      }

      .tab-content {
        overflow: auto;
        height: 100%;
        width: 100%;
        padding: 15px 22px;
        @media screen and (max-width: 991px) {
          overflow: inherit;
          padding: 15px 5px;
        }

        &::-webkit-scrollbar {
          width: 7px;
          border-radius: 0 !important;
        }
        &::-webkit-scrollbar-thumb {
          border-radius: 0 !important;
          cursor: pointer;
        }
      }
    }
  }

  &__back {
    font-size: 200%;
    position: absolute;
    left: 10px;
    top: 15px;
  }
}
.show-history-button {
  @media screen and (max-width: 991px) {
    display: none;
  }
}
</style>
